module.exports = __webpack_public_path__ + "static/header-image-premium-care-mobile-5f25a14c76920f318b2a23008e3bba2a.jpg";